export default __webpack_public_path__ + "static/media/TBDG 92_Benh vien Cai Lay_Nha xe 2 banh.f3ab76fe.pdf";